import type { BasePageConfig } from '@/pageConfig/BasePageConfig';
import { sharedConfig } from '@/pageConfig/shared';
import carServices from '@/static/partners/car.svg';
import embeddedPartnersImg from '@/static/partners/embedded-partners.svg';
import employers from '@/static/partners/employers.svg';
import onlineAffiliates from '@/static/partners/online-affiliates.svg';
import og from '@/static/partners/partners_program_og.png';
import propertyManagers from '@/static/partners/property-managers.svg';
import vet from '@/static/partners/vet.svg';

import carServicesMobile from '@/static/partners/car-mobile.svg';
import embeddedPartnersImgMobile from '@/static/partners/embedded-partners-mobile.svg';
import employersMobile from '@/static/partners/employers-mobile.svg';
import onlineAffiliatesMobile from '@/static/partners/online-affiliates-mobile.svg';
import propertyManagersMobile from '@/static/partners/property-managers-mobile.svg';
import vetMobile from '@/static/partners/vet-mobile.svg';

export interface Config extends BasePageConfig {
  hero: {
    title: string;
    subtitle: string;
    cta: string;
  };
  headerCta: {
    desktopText: string;
    mobileText: string;
  };
  whoIsThisFor: {
    title: string;
    targets: {
      name: string;
      src: StaticImageData;
      srcMobile: StaticImageData;
      title: string;
      subtitle: string;
    }[];
  };
  whyUs: {
    title: string;
    reasons: {
      key: string;
      title: string;
      subtitle: string;
    }[];
  };
  testimonials: {
    content: string;
    personName: string;
    personTitle: string;
  };
}

export const config: Config = {
  layout: { ...sharedConfig['en-US'].layout },
  seo: {
    title: "Lemonade's Partners Program | Grow Your Business!",
    description:
      'Tell the world about the most love insurance product out there, while earning $$ and creating real social impact.',
    ogImage: og.src,
    metaTitle: "Lemonade's Partners Program | Grow Your Business!",
  },
  hero: {
    cta: 'apply now',
    subtitle: 'Generate income, keep your customers happy. Easy sign up.',
    title: 'Grow your business by offering the\nworld’s most loved insurance',
  },
  headerCta: {
    desktopText: 'apply now',
    mobileText: 'apply',
  },
  whoIsThisFor: {
    title: 'Who is this for?',
    targets: [
      {
        name: 'partners',
        src: embeddedPartnersImg,
        srcMobile: embeddedPartnersImgMobile,
        title: 'Embedded Partners',
        subtitle: 'We partner with top brands in personal finance,\nreal estate, e\u2011commerce, and\u00A0more',
      },
      {
        name: 'Property-Managers',
        src: propertyManagers,
        srcMobile: propertyManagersMobile,
        title: 'Property Managers',
        subtitle: 'Provide hassle-free insurance coverage that your tenants will actually\u00A0love',
      },
      {
        name: 'Online-Affiliates',
        src: onlineAffiliates,
        srcMobile: onlineAffiliatesMobile,
        title: 'Online Affiliates',
        subtitle: 'From comparison sites to lifestyle blogs, we partner with a wide range of digital\u00A0publishers',
      },
      {
        name: 'Employers',
        src: employers,
        srcMobile: employersMobile,
        title: 'Employers',
        subtitle: 'Seamlessly provide insurance to employees and give them great additional\u00A0benefits',
      },
      {
        name: 'Car-Services',
        src: carServices,
        srcMobile: carServicesMobile,
        title: 'Car Services',
        subtitle: 'Sell cars or provide an amazing car product or service? Get in\u00A0touch',
      },
      {
        name: 'Vets',
        src: vet,
        srcMobile: vetMobile,
        title: 'Vets & Pet Services',
        subtitle: 'Have a vet office? Run a pet health or supply store? We’d love to hear from\u00A0you',
      },
    ],
  },
  whyUs: {
    title: 'Why partner with us?',
    reasons: [
      {
        key: 'revenue',
        title: 'New revenue streams',
        subtitle: 'We offer competitive partnership terms and\u00A0commissions',
      },
      {
        key: 'customers',
        title: 'Delight your customers',
        subtitle: 'We’re rated 4.9/5 stars on the app store and achieved a world-class NPS score higher than\u00A070',
      },
      {
        key: 'seamless',
        title: 'Seamless integration',
        subtitle: 'Through tracking links or our APIs, we can get you set up and selling\u00A0fast',
      },
    ],
  },
  testimonials: {
    content:
      'Lemonade understands that a partnership is a cooperation\nbetween two parties for mutual benefit. They also have an\nexcellent consumer product that our customers love.',
    personName: 'Miron Lulic',
    personTitle: 'CEO Supermoney',
  },
};
